import React from 'react';
import classNames from 'classnames';
import Button from 'components/styleguide/button/Button';
import Icon from 'components/styleguide/icon/Icon';

const styles = require('./SocialButton.module.scss');

export type SocialProvider = 'Google' | 'Microsoft' | 'Linkedin' | 'Facebook' | 'Github';

export interface SocialButtonProps {
  className?: string;
  dataMethod?: string;
  disabled?: boolean;
  href: string;
  provider: SocialProvider;
  rel?: string;
  target?: string;
}

const SocialButton: React.FC<SocialButtonProps> = ({
  className,
  dataMethod = 'post',
  disabled = false,
  href,
  provider,
  rel,
  target,
}) => {
  const label = `Sign in with ${provider}`;

  if (disabled) {
    return (
      <Button
        type="secondary"
        context="neutral"
        size="M"
        iconLeft={provider.toLowerCase()}
        iconLeftOptions={{ color: 'black' }}
        disabled
        className={classNames(styles.socialButton, className)}
        aria-label={label}
      >
        {provider}
      </Button>
    );
  }

  return (
    <a
      href={href}
      target={target}
      rel={rel || (target === '_blank' ? 'noopener noreferrer' : undefined)}
      data-method={dataMethod}
      className={classNames(styles.socialButton, className)}
      aria-label={label}
    >
      <Icon name={provider.toLowerCase()} size="md" aria-hidden="true" />
      <span>{provider}</span>
    </a>
  );
};

export default SocialButton;
